// 截取日期的前部分，精确到天
export function getTimeBeforeDay(arr, attr) { //arr遍历的数组，attr过滤的属性名
    if (Array.isArray(arr)) {
        for (let item of arr) {
            item[attr] = item[attr].split(' ')[0];
        }
        return arr;
    } else {
        return [];
    }
}

//获取二级菜单的名字
export function getNavName(item) { //除了处理跳转链接以外，还需要处理多语言（多语言的字段:cate_name:繁体，j_name：简体，e_name是英文）
    if (Array.isArray(item)) {
        let language = 1; //1简体；2繁体3英文

        return item.map((item) => {
            if (language == 1) {
                item.cate_name = item.j_name;
            } else if (language == 3) {
                item.cate_name = item.e_name;
            }
            return item;
        });
    } else {
        return []
    }
}